import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["content", "icon"]
  static values = {
    identifier: String
  }

  connect() {
    // Check if any child links are active
    const activeLink = this.contentTarget.querySelector('.bg-accent.text-accent-foreground')
    
    if (activeLink) {
      // If we have an active link, open the menu
      this.open()
    } else {
      // If no active link, clear any stored state and close
      localStorage.removeItem(`menuExpanded_${this.identifierValue}`)
      this.close()
    }
  }

  toggle() {
    if (this.contentTarget.classList.contains("hidden")) {
      this.open()
    } else {
      this.close()
    }
  }

  open() {
    this.contentTarget.classList.remove("hidden")
    this.contentTarget.style.maxHeight = `${this.contentTarget.scrollHeight}px`
    this.iconTarget.classList.add("-rotate-180")
    localStorage.setItem(`menuExpanded_${this.identifierValue}`, 'true')
  }

  close() {
    this.contentTarget.classList.add("hidden")
    this.contentTarget.style.maxHeight = "0"
    this.iconTarget.classList.remove("-rotate-180")
    localStorage.setItem(`menuExpanded_${this.identifierValue}`, 'false')
  }
}
